@if (displayedValue()) {
  <glxy-badge [color]="displayedColor()" [class.clickable]="clickableMenu">
    {{ displayedValue() | translate }}
    @if (clickableMenu) {
      <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
    }
  </glxy-badge>
}
